/*jshint -W117 */
(function () {
    'use strict';

    angular
        .module('app.user')
        .controller('UpdateUserCustomerController', UpdateUserCustomerController);

    function UpdateUserCustomerController($uibModalInstance, customerService, userService, data, ATAC) {

        var vm = this;
        vm.request = data;

        vm.title = 'User-Customer Transfer';
        vm.fromCustomerId = null;
        vm.toCustomerId = null;
        vm.stage = 1;
        vm.validation = getDefaultDataValidation();
        vm.usersCustomer = [];
        vm.isAllUsersSelected = false;

        vm.cancel = cancel;
        vm.nextStage = nextStage;
        vm.backStage = backStage;
        vm.save = save;
        vm.toggleAllUsers = toggleAllUsers;

        function cancel() {
            $uibModalInstance.close();
        }

        function nextStage() {
            var validate = function () {
                var isValid = true;

                if (!(vm.fromCustomerId)) {
                    vm.validation.isFromCustomerIdValid = false;
                    vm.validation.fromCustomerIdMessage = 'From Customer ID is not valid';
                    isValid = false;
                }

                if (!(vm.toCustomerId)) {
                    vm.validation.isToCustomerIdValid = false;
                    vm.validation.toCustomerIdMessage = 'To Customer ID is not valid';
                    isValid = false;
                }

                if (!(vm.fromCustomerId) && !(vm.toCustomerId) && vm.fromCustomerId === vm.toCustomerId) {
                    vm.validation.isFromCustomerIdValid = false;
                    vm.validation.fromCustomerIdMessage = 'From Customer ID is equal with To Customer ID';
                    vm.validation.isToCustomerIdValid = false;
                    vm.validation.toCustomerIdMessage = 'To Customer ID is equal with From Customer ID';
                    isValid = false;
                }

                return isValid;
            };

            vm.validation = getDefaultDataValidation();

            if (!validate()) {
                return;
            }

            customerService.checkIfCustomerExists(vm.fromCustomerId, vm.toCustomerId).then(function (result) {

                var fromCustomerExists = _.find(result, { CustomerID: vm.fromCustomerId });
                if (!fromCustomerExists) {
                    vm.validation.isFromCustomerIdValid = false;
                    vm.validation.fromCustomerIdMessage = 'From Customer ID is not exists';
                }

                var toCustomerExists = _.find(result, { CustomerID: vm.toCustomerId });
                if (!toCustomerExists) {
                    vm.validation.isToCustomerIdValid = false;
                    vm.validation.toCustomerIdMessage = 'To Customer ID is not exists';
                }

                if (fromCustomerExists && toCustomerExists) {
                    vm.stage = 2;
                    loadUsers();
                }
            });
        }

        function backStage() {
            vm.fromCustomerId = null;
            vm.toCustomerId = null;
            vm.stage = 1;
        }

        function loadUsers() {
            vm.usersCustomer = [];
            ATAC.showLoader();
            userService.getUserByCustomerId(vm.fromCustomerId).then(function (result) {
                _.each(result.data, function (res) {
                    var user = {
                        UserId: res.UserId,
                        IsSelected: false,
                        Email: res.Email,
                        FullName: res.FullName
                    };
                    vm.usersCustomer.push(user);
                });

                ATAC.hideLoader();
            });
        }

        function toggleAllUsers() {
            vm.isAllUsersSelected = !vm.isAllUsersSelected;
            _.each(vm.usersCustomer, function (user) {
                user.IsSelected = vm.isAllUsersSelected;
            });
        }

        function save() {
            var getUsersForMove = function () {
                var ret = [];
                _.each(vm.usersCustomer, function (user) {
                    if (user.IsSelected) {
                        ret.push(user.UserId);
                    }
                });

                return ret;
            };

            var validate = function (userForMove) {
                var isValid = true;

                if (userForMove.length === 0) {
                    vm.validation.isShowUserMessage = true;
                    vm.validation.isUsserSuccess = false;
                    vm.validation.usersMessage = 'Please select user(s) for transfer';
                    isValid = false;
                }

                return isValid;
            };

            vm.validation = getDefaultDataValidation();

            var userForMove = getUsersForMove();
            if (!validate(userForMove)) {
                return;
            }

            userService.bulkMoveUsers(vm.toCustomerId, userForMove).then(function (result) {
                ATAC.hideLoader();

                loadUsers();

                var message = 'Bulk user(s) move was successful';
                var isSuccess = true;

                if (result.status !== 200) {
                    logger.info('Bulk user(s) move was failed');
                    message = 'Bulk user(s) move was failed';
                    isSuccess = false;

                } else {
                    _.each(result.data, function (res) {
                        if (!res.IsSuccess) {
                            isSuccess = false;
                            message += ' Sync for user ' + res.FullName +
                                ' falied with description ' + res.Description;
                        }
                    });
                }

                vm.validation.usersMessage = message;
                vm.validation.isUsserSuccess = isSuccess;
                vm.validation.isShowUserMessage = true;
            });
        }

        function getDefaultDataValidation() {
            return {
                isFromCustomerIdValid: true,
                fromCustomerIdMessage: '',
                isToCustomerIdValid: true,
                toCustomerIdMessage: '',
                isShowUserMessage: false,
                usersMessage: '',
                isUsserSuccess: false
            };
        }
    }
})();
